import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiKeysService } from "@/services/apiKeysService";
import type { ApiKeyCreateRequest } from "@/types/apiKey";

const QUERY_KEY = ["api-keys"];

export function useApiKeys() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => apiKeysService.list(),
  });
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ApiKeyCreateRequest) => apiKeysService.create(data),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}

export function useRevokeApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => apiKeysService.revoke(uuid),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}

export function useRotateApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => apiKeysService.rotate(uuid),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
